import { useEffect, useMemo, useState } from "react";
import { useRouter } from "next/router";
import axios from "axios";

const NEXT_PUBLIC_BLOGS_KEY = process.env.NEXT_PUBLIC_BLOGS_KEY;

export const key = NEXT_PUBLIC_BLOGS_KEY; //needs to be moved to secrets
const max = 2000;
interface useBlogProps {
  page?: number;
  limit?: number;
  search?: string;
  data?: any;
}
export const useBlog = ({
  page = 1,
  limit = 9,
  search,
  data,
}: useBlogProps) => {
  const router = useRouter();
  const [blogs, setBlogs] = useState<any>(data);
  const [loading, setLoading] = useState<boolean>(data ? false : true);

  useEffect(() => {
    //useRouter wont get params initially so I am using params from location.search
    if (!data) {
      const search = window.location.search.substring(1);
      const params = new URLSearchParams(search);
      const slug = params.get("slug");
      if (slug) {
        fetchPost(slug);
      } else {
        fetchAllBlog();
      }
    }
  }, []);

  const fetchPost = (slug: string) => {
    const params: any = {
      key,
      include: "authors,tags",
    };
    if (slug !== "") {
      axios
        .get(
          `https://www.staderlabs.com/blog/ghost/api/content/posts/slug/${slug}`,
          { params }
        )
        .then((res: any) => {
          setBlogs(res.data);
          setLoading(false);
        })
        .catch((err) => console.log("fetchPost err", err));
    }
  };

  const fetchAllBlog = () => {
    const params: any = {
      key,
      page: 1,
      limit: max,
      include: "authors,tags",
    };
    axios
      .get(`https://www.staderlabs.com/blog/ghost/api/content/posts/`, {
        params,
      })
      .then((res: any) => {
        setBlogs(res.data);
        setLoading(false);
      })
      .catch((err) => console.log("fetchAllBlog err", err));
  };

  const paginate = (items: any, page_size: number) => {
    const num_pages = Math.ceil(items.length / page_size);
    const paginated = [];
    for (let i = 0; i < num_pages; i++) {
      const start = i * page_size;
      const page = items.slice(start, start + page_size);
      paginated.push(page);
    }
    return paginated;
  };

  const applyFilters = (data: any) => {
    const xTag = router.query?.tag;

    if (xTag && xTag !== "all") {
      const y = { ...data };
      let z: any = [];

      y.posts.forEach((obj: any) => {
        obj.tags.forEach((tag: any) => {
          if (tag.slug === xTag) {
            z.push(obj);
          }
        });
      });
      y.posts = z;
      return y;
    }
    return data;
  };

  const applySearch = (data: any) => {
    if (search && search !== "") {
      let x = { ...data };
      x.posts = x.posts.filter(
        (post: any) =>
          post.html.toLowerCase().includes(search.toLowerCase()) ||
          post.title.toLowerCase().includes(search.toLowerCase())
      );
      return x;
    }
    return data;
  };

  const getData = (data: any) => {
    if (data) {
      let xData = { ...applyFilters(data) };
      xData = { ...applySearch(xData) };
      const newPage = router.query?.page || page;
      const x = paginate(xData.posts, limit);
      const meta = {
        pagination: {
          page: Number(newPage),
          pages: x.length,
        },
      };
      const posts = x[Number(newPage) - 1];
      return { meta, posts };
    }
    return null;
  };

  const blogsData = useMemo(() => {
    return getData(blogs);
  }, [page, limit, router, blogs, search]);

  return {
    blogs: blogsData,
    loading,
  };
};
